module.exports = __webpack_public_path__ + "static/media/marker_bus_stop.a931f69c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_bus_stop.svg
// module id = 242
// module chunks = 0